import { useSelector } from "react-redux";

import type { LeadsType } from "app/pages/sales-intelligence/modules/leads-search";
import {
    createExcelExportRequestDto,
    selectActiveSearchResultsDto,
    useLeadsExcelExportMutation,
} from "app/pages/sales-intelligence/modules/leads-search";
import { useSearchDemoMode } from "app/pages/sales-intelligence/modules/leads-search/hooks/useSearchDemoMode";
import { withDemoMode } from "app/pages/sales-intelligence/modules/leads-search/query/options";
import { useListParams } from "app/pages/sales-intelligence/modules/lists/context/ListParamsContext";
import salesApiService from "app/pages/sales-intelligence/services/salesApiService";
import { useSignalNamesById } from "app/pages/sales-intelligence/sub-modules/signals/hooks/useUISignals";
import { removeHTMLTagsFromSignalNames } from "app/pages/sales-intelligence/sub-modules/signals/utils/removeHTMLTags";
import { exportLeadsToExcelService } from "app/pages/sales-intelligence/sub-modules/table-actions-panel/services/exportExcelService";

export const useExcelExportMutation = (leadsType: LeadsType) => {
    const listParams = useListParams();

    const searchRequestDto = useSelector(selectActiveSearchResultsDto);
    const signalNamesByIds = useSignalNamesById();
    // Export stays enabled during a demo, so the file must reflect the same dataset the table is previewing.
    const demoMode = useSearchDemoMode();

    return useLeadsExcelExportMutation({
        mutationFn(domainsOrCount) {
            return salesApiService.opportunityListPage.exportLeadsToExcel({
                listParams,
                leadsType,
                dto: createExcelExportRequestDto(
                    withDemoMode(searchRequestDto, demoMode),
                    removeHTMLTagsFromSignalNames(signalNamesByIds),
                    domainsOrCount,
                ),
            });
        },
        toastService: exportLeadsToExcelService[leadsType],
    });
};
